import { mergeStyles } from '../../../../../internal/utils/mergeStyles';
import mainStyles from './styles.module.css';
export const getStyles = size => {
  return mergeStyles(mainStyles, require("./size/".concat(size, ".module.css")));
};